export enum AppEvent {
	Click = '[AppEvent] Click',
	LEFT = '[AppEvent] LEFT',
	RIGHT = '[AppEvent] RIGHT',
	TAB = '[AppEvent] TAB'
}
